import React, { useEffect, useState } from "react";
import { IoMoon, IoSunny, IoMenu, IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";
import resume from "../assets/BillieZhangResume.pdf";

const NavBar = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    document.documentElement.classList.toggle("dark");
  };

  const links = [
    { id: 1, link: "projects", url: "/projects" },
    { id: 2, link: "about", url: "/about" },
    { id: 3, link: "resume", url: resume, external: true },
  ];

  const showScrolledStyle = scrolled && !isMenuOpen;

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${showScrolledStyle ? "py-4" : "py-8"}`}>
      <div
        className={`text-text max-w-6xl mx-auto w-[92%] transition-all duration-500 px-8 py-3 flex items-center justify-between rounded-full border relative z-50 
        ${showScrolledStyle
            ? "bg-white/80 dark:bg-black/50 backdrop-blur-xl shadow-lg border-white/10"
            : "bg-transparent border-transparent"
          }`}
      >

        <Link to="/" onClick={() => setIsMenuOpen(false)} className="text-2xl font-bold tracking-wide hover:opacity-80 transition-opacity">
          <h1>bz.</h1>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map(({ id, link, url, external }) => (
            external ? (
              <a key={id} href={url} target="_blank" rel="noreferrer" className="text-xs uppercase tracking-widest font-semibold hover:opacity-70 transition-colors">
                {link}
              </a>
            ) : (
              <Link key={id} to={url} className="text-xs uppercase tracking-widest font-semibold hover:opacity-70 transition-colors">
                {link}
              </Link>
            )
          ))}
          <button onClick={toggleDarkMode} className="ml-4 p-2 rounded-full hover:bg-black/5 dark:hover:bg-white/10 transition-colors">
            {isDarkMode ? <IoSunny size={18} /> : <IoMoon size={18} />}
          </button>
        </div>

        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-2xl relative z-50 hover:opacity-70 transition-opacity">
          {isMenuOpen ? <IoClose /> : <IoMenu />}
        </button>
      </div>

      {isMenuOpen && (
        <div className="fixed inset-0 bg-background flex flex-col items-center justify-center space-y-10 md:hidden z-40">
          {links.map(({ id, link, url, external }) => (
            <Link key={id} to={url} onClick={() => setIsMenuOpen(false)} className="text-4xl font-bold tracking-tighter hover:opacity-80 transition-colors">
              {link}
            </Link>
          ))}
          <button onClick={toggleDarkMode} className="text-xl p-4 rounded-full">
            {isDarkMode ? <IoSunny /> : <IoMoon />}
          </button>
        </div>
      )}
    </nav>
  );
};

export default NavBar;